import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-qs-input',
  templateUrl: './qs-input.component.html',
  styleUrls: ['./qs-input.component.scss', '../inputs.scss'],
  standalone: false,
})
export class QsInputComponent implements OnInit {
  @Input() label = '';
  @Input() placeholder = '';
  @Input() type = 'text';
  @Input() disabled = false;
  @Input() controllerName = '';
  @Input() multiline = false;
  @Input() outlined = false;
  @Input() required = false;
  @Input() rows = 4;
  /**
   * Stable hook for end-to-end tests. Set it on the wrapper and it lands on the rendered
   * <input> or <textarea>, so specs never depend on this markup or on the translated label.
   */
  @Input() testId = '';

  qsInputControl!: FormControl;

  constructor(private controlContainer: ControlContainer) {}

  ngOnInit() {
    const parentGroup = this.controlContainer.control as FormGroup;

    if (parentGroup) {
      this.qsInputControl = parentGroup.get(this.controllerName) as FormControl;

      if (!this.qsInputControl) {
        console.error(
          `FormControl with name '${this.controllerName}' not found.`,
        );
      }
    } else {
      console.error('Parent FormGroup not found.');
    }
  }
}
